import { render, staticRenderFns } from "./plannedInstitutionsListItem.vue?vue&type=template&id=6e594027"
import script from "./plannedInstitutionsListItem.vue?vue&type=script&lang=ts"
export * from "./plannedInstitutionsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports